// Shared renderer for PMax per-campaign on/off setting checks (Text Customization, Video
// Enhancements). Evidence carries the setting label, so one component serves both. The headline
// rationale is rendered above by the FindingCard summary; this is the per-campaign breakdown.

import type { EvidenceProps } from './registry';

interface CampaignRow {
  id?: string;
  name: string;
  enabled: boolean;
}

interface ToggleSettingShape {
  totalCampaigns: number;
  onCount: number;
  offCount: number;
  setting: string;
  campaigns: CampaignRow[];
}

export const PmaxToggleSettingEvidence = ({ evidence }: EvidenceProps) => {
  const e = evidence as unknown as ToggleSettingShape;

  return (
    <div className='evidence'>
      <section className='evidence__section'>
        <h4 className='evidence__section-title'>
          {e.setting}
          <span className='evidence__section-tag evidence__section-tag--context'>
            {e.totalCampaigns} PMax campaigns
          </span>
        </h4>
        <div className='audience-coverage'>
          <div className='audience-coverage__cell'>
            <div className='audience-coverage__num'>{e.onCount.toLocaleString()}</div>
            <div className='audience-coverage__lbl'>On</div>
          </div>
          <div className='audience-coverage__cell'>
            <div className='audience-coverage__num'>{e.offCount.toLocaleString()}</div>
            <div className='audience-coverage__lbl'>Off</div>
          </div>
        </div>
      </section>

      <section className='evidence__section'>
        <h4 className='evidence__section-title'>Per-campaign setting</h4>
        <table className='evidence__table evidence__table--pmax-final-url'>
          <thead>
            <tr>
              <th>Campaign</th>
              <th>{e.setting}</th>
            </tr>
          </thead>
          <tbody>
            {e.campaigns.map(c => (
              <tr key={c.id ?? c.name}>
                <td>{c.name}</td>
                <td>
                  <span
                    className={`evidence__strength ${
                      c.enabled ? 'evidence__strength--good' : 'evidence__strength--average'
                    }`}
                  >
                    {c.enabled ? 'On' : 'Off'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
};
